import { render, staticRenderFns } from "./product-form.vue?vue&type=template&id=d421ada2&scoped=true&lang=pug&"
import script from "./product-form.vue?vue&type=script&lang=ts&"
export * from "./product-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d421ada2",
  null
  
)

export default component.exports